module.exports = __webpack_public_path__ + "img/section4_title.1a512e50.png";